const TypeConfig = {
    dropdown: {
        alignment: (type) => ([
            { display: 'Left', value: type == 'flex' ? 'flex-start' : 'left' },
            { display: 'Center', value: 'center' },
            { display: 'Right', value: type == 'flex' ? 'flex-end' : 'right' }
        ]),

        measurement: (includePercent) => {
            const options = [{ display: 'PX', value: 'px' }];
            if (includePercent == true) {
                options.push({ display: '%', value: '%' });
            }
            return options;
        }
    },

    options: {
        border: function () {
            return [
                { display: 'Border Properties', id: 'borderProps', type: 'header' },
                {
                    display: 'Top Border',
                    name: 'borderTop',
                    type: 'text'
                },
                {
                    display: 'Top Border Spacing',
                    name: 'borderTopSpacing',
                    type: 'text'
                },
                {
                    display: 'Bottom Border',
                    name: 'borderBottom',
                    type: 'text'
                },
                {
                    display: 'Bottom Border Spacing',
                    name: 'borderBottomSpacing',
                    type: 'text'
                }
            ];
        },
        currency: function (props) {
            const _props = props || {};
            const _name = _props.name || '';
            const option = {
                display: _props.display || 'Currency Format',
                fullWidth: true,
                name: `currencyFormat${_name}`,
                type: 'currencyFormat',
                visible: _props.visible
            };
            if (_props.includeHelpText != false) {
                option.helpText = () => 'Keywords: [CurrencySymbol], [ThousandsSep], [DecimalSep]';
            }
            return option;
        },
        firstPageOnly: (group) => {
            return {
                display: 'Only Show On First Page',
                group,
                fullWidth: true,
                name: 'renderOnlyFirst',
                type: 'checkbox',
                value: false,
                visible: (_, parentConfig, isBodyBlock) => !parentConfig && isBodyBlock
            };
        },
        percent: function (props) {
            const _props = props || {};
            const _name = _props.name || '';
            const option = {
                display: _props.display || 'Percent Format',
                fullWidth: _props.fullWidth,
                name: `percentFormat${_name}`,
                type: 'percentFormat',
                visible: _props.visible
            }
            if (_props.includeHelpText != false) {
                option.helpText = () => 'Keywords: [Value]';
            }
            return option;
        },
        text: function (props, fontStyle, textTransform, lineSpacing) {
            const _props = props || {};
            const _name = _props.name || '';
            const options = [
                {
                    display: 'Collateral Style',
                    name: `style${_name}`,
                    options: [
                        { display: 'Header', value: 'header' },
                        { display: 'Body', value: 'body' }
                    ],
                    type: 'dropdown',
                    value: 'body',
                    visible: _props.visible
                },
                {
                    display: 'Override Text Color',
                    name: `color${_name}`,
                    type: 'text',
                    visible: _props.visible
                },
                {
                    display: 'Text Size',
                    name: `fontSize${_name}`,
                    type: 'text',
                    visible: _props.visible
                },
                {
                    display: 'Line Height',
                    name: `lineHeight${_name}`,
                    type: 'text',
                    visible: _props.visible
                },
                {
                    display: 'Font Weight',
                    name: `fontWeight${_name}`,
                    type: 'text',
                    visible: _props.visible
                },
            ];
            if (fontStyle) {
                options.push({
                    display: 'Font Style',
                    name: `fontStyle${_name}`,
                    options: [
                        { display: 'Normal', value: 'normal' },
                        { display: 'Italic', value: 'italic' }
                    ],
                    type: 'dropdown',
                    value: fontStyle.value || 'normal',
                    visible: fontStyle.visible || _props.visible
                });
            }
            if (textTransform) {
                options.push({
                    display: 'Text Transform',
                    name: `textTransform${_name}`,
                    options: [
                        { display: 'None', value: 'none' },
                        { display: 'Capitalize', value: 'capitalize' },
                        { display: 'Uppercase', value: 'uppercase' },
                        { display: 'Lowercase', value: 'lowercase' }
                    ],
                    type: 'dropdown',
                    value: textTransform.value || 'none',
                    visible: textTransform.visible || _props.visible
                });
            }
            if (lineSpacing) {
                options.push({
                    display: 'Line Spacing',
                    name: `lineSpacing${_name}`,
                    type: 'text',
                    visible: lineSpacing.visible || _props.visible
                });
            }
            return options;
        },
        textV2: (group, props, fontStyle, textTransform, lineSpacing) => {
            const _props = props || {};
            const _name = _props.name || '';
            const options = [
                {
                    display: 'Collateral Style',
                    group,
                    name: `style${_name}`,
                    options: [
                        { display: 'Header', value: 'header' },
                        { display: 'Body', value: 'body' }
                    ],
                    type: 'dropdown',
                    value: 'body',
                    visible: _props.visible
                },
                {
                    display: 'Override Text Color',
                    group,
                    name: `color${_name}`,
                    type: 'color',
                    visible: _props.visible
                },
                {
                    display: 'Text Size',
                    group,
                    name: `fontSize${_name}`,
                    options: TypeConfig.dropdown.measurement(),
                    type: 'measurement',
                    visible: _props.visible
                },
                {
                    display: 'Line Height',
                    group,
                    name: `lineHeight${_name}`,
                    options: TypeConfig.dropdown.measurement(),
                    type: 'measurement',
                    visible: _props.visible
                },
                {
                    display: 'Font Weight',
                    group,
                    name: `fontWeight${_name}`,
                    options: [
                        { display: 'Normal', value: 'normal' },
                        { display: 'Bold', value: 'bold' }
                    ],
                    type: 'dropdown',
                    value: 'normal',
                    visible: _props.visible
                },
            ];
            if (fontStyle) {
                options.push({
                    display: 'Font Style',
                    group,
                    name: `fontStyle${_name}`,
                    options: [
                        { display: 'Normal', value: 'normal' },
                        { display: 'Italic', value: 'italic' }
                    ],
                    type: 'dropdown',
                    value: fontStyle.value || 'normal',
                    visible: fontStyle.visible || _props.visible
                });
            }
            if (textTransform) {
                options.push({
                    display: 'Text Transform',
                    group,
                    name: `textTransform${_name}`,
                    options: [
                        { display: 'None', value: 'none' },
                        { display: 'Capitalize', value: 'capitalize' },
                        { display: 'Uppercase', value: 'uppercase' },
                        { display: 'Lowercase', value: 'lowercase' }
                    ],
                    type: 'dropdown',
                    value: textTransform.value || 'none',
                    visible: textTransform.visible || _props.visible
                });
            }
            if (lineSpacing) {
                options.push({
                    display: 'Line Spacing',
                    group,
                    name: `lineSpacing${_name}`,
                    options: TypeConfig.dropdown.measurement(),
                    type: 'measurement',
                    visible: lineSpacing.visible || _props.visible
                });
            }
            return options;
        }
    },
    panel: {
        currency: function (props) {
            const _props = props || {};
            const options = [];
            if (_props.customFirstLineFormat) {
                options.push(TypeConfig.options.currency({ display: 'First Item Currency Format', name: 'First' }));
            }
            options.push(TypeConfig.options.currency({ includeHelpText: !_props.customFirstLineFormat }));
            if (_props.percent) {
                if (_props.customFirstLineFormat) {
                    options.push({ type: 'spacer' });
                    options.push({ type: 'spacer' });
                    options.push(TypeConfig.options.percent({ display: 'First Item Percent Format', name: 'First' }));
                }
                options.push(TypeConfig.options.percent({ fullWidth: !_props.customFirstLineFormat, includeHelpText: !_props.customFirstLineFormat }));
            }
            return {
                expanded: false,
                label: 'Advanced',
                options: options
            };
        },
        layoutStyle: function (padding, alignment, minHeight) {
            const _padding = padding || {};
            const options = [
                { display: 'Padding Top', name: 'paddingTop', type: 'text', value: _padding.top },
                { display: 'Padding Bottom', name: 'paddingBottom', type: 'text', value: _padding.bottom },
                { display: 'Padding Left', name: 'paddingLeft', type: 'text', value: _padding.left },
                { display: 'Padding Right', name: 'paddingRight', type: 'text', value: _padding.right }
            ];
            if (alignment) {
                options.push({
                    display: alignment.title || 'Text Alignment',
                    name: 'textAlign',
                    options: [
                        { display: 'Left', value: 'left' },
                        { display: 'Center', value: 'center' },
                        { display: 'Right', value: 'right' }
                    ],
                    type: 'dropdown',
                    value: alignment.value || 'left',
                    visible: alignment.visible
                });
            }
            if (minHeight) {
                options.push({ display: 'Minimum Height', name: 'minHeight', type: 'text', value: minHeight.value, visible: minHeight.visible });
            }
            return {
                expanded: false,
                label: 'Layout Style',
                options: options
            };
        },
        layoutStyleV2: (group, label, padding, alignment, minHeight) => {
            const options = [{
                disabled: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
                display: 'Padding',
                group,
                name: 'paddingMargin',
                options: TypeConfig.dropdown.measurement(),
                type: 'paddingMargin',
                value: padding
            }];
            if (alignment) {
                options.push({
                    display: alignment.title || 'Text Alignment',
                    group,
                    name: 'textAlign',
                    options: TypeConfig.dropdown.alignment(),
                    type: 'dropdown',
                    value: alignment.value || 'left',
                    visible: alignment.visible
                });
            }
            if (minHeight) {
                options.push({ 
                    display: 'Minimum Height',
                    fullWidth: true,
                    group,
                    name: 'minHeight', 
                    options: TypeConfig.dropdown.measurement(true),
                    type: 'measurement-slider', 
                    value: minHeight.value, 
                    visible: minHeight.visible 
                });
            }
            return {
                group,
                label,
                options
            };
        }
    }
};

module.exports = TypeConfig;